import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppConfig } from '../../_helpers/appconfig.service';
import { DataService } from '../../_helpers/dataservice.service';
import { ForgotPassword } from '../../_models/index';
import { UserService } from '../../_services/user.service';


@Component({
    selector: 'forgotpwd',
    templateUrl: './forgotpassword.component.html',
    styleUrls: [
        '../../../assets/css/customer-list-table.css',
        './forgotpassword.component.css'
    ]
})

export class ForgotPwdComponent implements OnDestroy {
    public passwordForm: FormGroup;
    showForgetPassword: boolean = false;
    private destroy$ = new Subject<void>();

    constructor(
            private _fb: FormBuilder, 
            private router: Router, 
            private userService: UserService,
            private dataService: DataService)
            {
        this.InitialSetup();
        this.showForgetPassword = true;
        this.dataService.hideHeader(true);
    }

    InitialSetup() {
        this.passwordForm = this._fb.group({
            client_id: new FormControl(""),
            email: new FormControl("", [Validators.required, Validators.email]),
            connection: new FormControl("Username-Password-Authentication")
        });
    }




    onsubmitpass({ value }: { value: ForgotPassword }) {
        value.client_id = AppConfig.settings.auth0config.clientID.toString();
        this.userService.forgotpassword(value)
            .subscribe((result) => {
                this.showForgetPassword = false;
            }, e => {
                this.passwordForm.reset();

                this.showForgetPassword = false;
            });
    }

    goToLogin() {
        this.router.navigate(['/login']);
    }

    ngOnDestroy() {
        this.dataService.hideHeader(false);
        this.destroy$.next();
        this.destroy$.complete();
    }
}
